

































import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import IndicatorFilter from '@superComponents/Indicator/IndicatorFilter'

settings =
  name: 'IndicatorResourceList'

  vue:
    props: ['indicators', 'infiniteWrapper', 'actions', 'options']
    components: {
      ResourceList,
      LoadingIndicator,
      IndicatorFilter,
    }

    data: ->
      isAllSelected: false
      selectedIndicators: []
      nextPage: 1

      target:
        status: null
        indicator_key: null

    computed:
      components: ->
        'indicator-card': () => import('@ui/cards/IndicatorCard')

      resourceKey: ->
        @options?.resourceKey || 'indicators'

      listItemActions: ->
        trust: @actions?.trust
        untrust: @actions?.untrust

    methods:
      hiApplyFilters: ->
        @nextPage = 1
        @actions.fetchResource null, @resourceKey, { @target }, { page: @nextPage }
        @nextPage += 1

      hiSearchChange: ->

      hiInfiniteScroll: (state) ->
        @actions.fetchResource state, @resourceKey, { @target }, { page: @nextPage }
        @nextPage += 1

      refreshInfinityScroll: ->
        @nextPage = 1
        @hiInfiniteScroll()

export default VueOptions.vue settings
